import { LoadingLayout } from 'components';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { getRepresentativeClientMainInfo } from '../helpers';
import { useRepresentativeClient } from '../hooks';
import { RepresentativeClientView } from '../views';

export const RepresentativeClientContainer = () => {
  const {
    representativeClient,
    loading,
    countries,
    countriesLoading,
    error,
    initialValues,
    submitLoading,
    breadcrumbsTitles,
    revokeOtpVerificationLoading,
    lockClientIfPossible,
    unlockClient,
    onSubmit,
    onShowVersionHistory,
    onRevokeOtpVerification,
  } = useRepresentativeClient();

  if (error || (!representativeClient && !loading)) {
    return <ErrorFallback />;
  }

  if (loading || !representativeClient) {
    return <LoadingLayout />;
  }

  const mainInfo = getRepresentativeClientMainInfo(representativeClient);

  return (
    <RepresentativeClientView
      breadcrumbsTitles={breadcrumbsTitles}
      countries={countries}
      countriesLoading={countriesLoading}
      initialValues={initialValues}
      kycData={representativeClient.kyc}
      lockClientIfPossible={lockClientIfPossible}
      mainInfo={mainInfo}
      revokeOtpVerificationLoading={revokeOtpVerificationLoading}
      submitLoading={submitLoading}
      unlockClient={unlockClient}
      onRevokeOtpVerification={onRevokeOtpVerification}
      onShowVersionHistory={onShowVersionHistory}
      onSubmit={onSubmit}
    />
  );
};
